import { render, staticRenderFns } from "./CartInfoCard.vue?vue&type=template&id=c8fe8f74"
import script from "./CartInfoCard.vue?vue&type=script&lang=js"
export * from "./CartInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports